import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { ControltowerService } from 'src/app/services/dashboards/controltower.service';

@Component({
  selector: 'neoris-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})
export class DashboardComponent implements OnInit {
  @ViewChild('iframeElement') iframeElement: ElementRef;
  //iframeSrc = 'https://example.com';
  errorMessage: string;

  ip: string;
  isVpn: boolean;

  constructor(private serviceObject:ControltowerService,
    private msalService: MsalService
  ) { 
    console.log('minidashboard constructor')
  }


  ngAfterViewInit() {
    const iframe = this.iframeElement.nativeElement;
    let loadTimeout: any;

    iframe.onload = () => {
      clearTimeout(loadTimeout);
      console.log('Iframe loaded successfully');
    };

    loadTimeout = setTimeout(() => {
      this.errorMessage = 'Failed to load iframe content';
      console.error('Failed to load iframe content');
    }, 5000); // Timeout after 5 seconds
  }

  ngOnInit(): void {
   
   

    /*this.serviceObject.getIp().subscribe(
      (data: any) => {
        this.ip = data.ip;
      },
      (error) => {
        //let json = JSON.parse(error.error.text)
        const ipMatch = /"ip":"(\d+\.\d+\.\d+\.\d+)"/.exec(error.error.text);
        console.error('Error fetching IPs:', ipMatch[1]);
        this.serviceObject.getIpInfo(ipMatch[1]).subscribe(
          (info: any) => {
            if (info && info.org) {
              console.log('info',info)
              console.log('is vpn',info.org.toLowerCase())
              this.isVpn = info.org.toLowerCase().includes('vpn');
              console.log('confirm vpn',this.isVpn)
            } else {
              this.isVpn = false;
            }
          },
          (error) => {
            console.error('Error fetching IP info:', error);
            this.isVpn = false;
          }
        );



      }
    );
*/

    /*this.serviceObject.getIp().subscribe(
      (ip: string) => {
        this.ip = ip;
        this.serviceObject.getIpInfo(ip).subscribe(
          (info: any) => {
            if (info && info.org) {
              console.log('is vpn',info.org.toLowerCase())
              this.isVpn = info.org.toLowerCase().includes('vpn');
            } else {
              this.isVpn = false;
            }
          },
          (error) => {
            console.error('Error fetching IP info:', error);
            this.isVpn = false;
          }
        );
      },
      (error) => {
        console.error('Error fetching IP:', error);
      }
    );*/

/*
    this.serviceObject.getLocalIp().then(
      (ips: string[]) => {
        console.log('----->',ips)
      },
      (error) => {
        console.error('Error fetching local IPs:', error);
      }
    );
*/  
  }

}
